module.exports = __webpack_public_path__ + "static/original-mattress-1-14dcccb461b22afc2d271e68317afb44.mp4";